import React, { Component } from "react";
import JsBarcode from "jsbarcode";
import DeliveryEntity from "../../types/deliveryEntity.type";
import { Geocoding } from "../../utils/Geocoding";

type Props = {
  listItems: DeliveryEntity[];
  onEdit: (delivery: DeliveryEntity) => void;
  onDelete: (deliveryId: number) => void;
  onStatusChange: (deliveryId: number, status: string) => void;
};

type State = {
  addresses: Record<number, { start?: string; end?: string }>;
};

export default class DeliveryList extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      addresses: {},
    };
  }

  async componentDidMount() {
    await this.loadAddresses();
    this.renderBarcodes();
  }

  async componentDidUpdate(prevProps: Props) {
    if (prevProps.listItems !== this.props.listItems) {
      await this.loadAddresses();
      this.renderBarcodes();
    }
  }

  private async loadAddresses() {
    const addresses: Record<number, { start?: string; end?: string }> = {};

    for (const d of this.props.listItems) {
      if (d.id == null) continue;
      const startAddress = await Geocoding.reverseGeocode(
        d.startLatitude,
        d.startLongitude
      );
      const endAddress = await Geocoding.reverseGeocode(
        d.endLatitude,
        d.endLongitude
      );

      addresses[d.id] = {
        start: startAddress ?? "Unknown",
        end: endAddress ?? "Unknown",
      };
    }

    this.setState({ addresses });
  }

  private renderBarcodes() {
    console.log("Rendering barcodes for deliveries:", this.props.listItems);
    console.log(
      "Valid deliveries for barcodes:",
      this.props.listItems.filter((d) => d.id != null && d.barcode != null)
    );
    setTimeout(() => {
      this.props.listItems.forEach((d) => {
        if (d.id == null || d.barcode == null) {
          console.warn(`Skipping barcode for delivery ID ${d.id}: invalid ID or barcode`);
          return;
        }
        try {
          const canvas = document.getElementById(`barcode-${d.id}`) as HTMLCanvasElement;
          if (canvas) {
            JsBarcode(canvas, d.barcode, {
              format: "CODE128",
              width: 2,
              height: 40,
              displayValue: true,
              fontSize: 12,
              margin: 0,
            });
            console.log(`Barcode rendered for delivery ID ${d.id}: ${d.barcode}`);
          } else {
            console.warn(`Canvas not found for barcode-${d.id}`);
          }
        } catch (error) {
          console.error(`Failed to render barcode for delivery ID ${d.id}:`, error);
        }
      });
    }, 0);
  }

  render() {
    console.log("DeliveryList listItems:", this.props.listItems);
    const statusOptions = ["IDLE", "ASSIGNED", "PICKING_UP", "DELIVERING", "DELIVERED", "DONE"];

    const listItems = this.props.listItems.map((d) => (
      <tr key={d.id ?? Math.random()}>
        <td>{d.deliveryTitle ?? "N/A"}</td>
        <td>{d.description ?? "N/A"}</td>
        <td>
          {d.barcode ? (
            <canvas
              id={`barcode-${d.id}`}
              style={{ width: "100px", height: "40px" }}
            ></canvas>
          ) : (
            "N/A"
          )}
        </td>
        <td>{d.userId ?? "N/A"}</td>
        <td>
          <select style={{ width: "auto" }}
            value={d.status ?? ""}
            onChange={(e) => {
              if (d.id != null) {
                console.log(`Status changed for delivery ID ${d.id}: ${e.target.value}`);
                this.props.onStatusChange(d.id, e.target.value || "IDLE");
              }
            }}
            className="form-control"
            disabled={d.id == null}
          >
            <option value="" disabled>
              Select Status
            </option>
            {statusOptions.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </select>
        </td>
        <td>
          {this.state.addresses[d.id]?.start ??
            `LONG: ${d.startLongitude ?? "N/A"}, LAT: ${d.startLatitude ?? "N/A"}`}
        </td>
        <td>
          {this.state.addresses[d.id]?.end ??
            `LONG: ${d.endLongitude ?? "N/A"}, LAT: ${d.endLatitude ?? "N/A"}`}
        </td>
        <td>{d.createdAt ?? "N/A"}</td>
        <td>{d.updatedAt ?? "N/A"}</td>
        <td>
          <button
            onClick={() => {
              console.log("Edit button clicked for delivery:", d);
              this.props.onEdit(d);
            }}
            className="btn btn-primary btn-sm"
            disabled={d.id == null}
          >
            Edit
          </button>
        </td>
        <td>
          <button
            onClick={() => {
              console.log("Delete button clicked for delivery ID:", d.id);
              d.id != null && this.props.onDelete(d.id);
            }}
            className="btn btn-danger btn-sm"
            disabled={d.id == null}
          >
            Delete
          </button>
        </td>
      </tr>
    ));

    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Barcode</th>
            <th>Adder ID</th>
            <th>Status</th>
            <th>Start Location</th>
            <th>End Location</th>
            <th>Created</th>
            <th>Updated</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>{listItems}</tbody>
      </table>
    );
  }
}